var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('p',{staticClass:"wrapper__title"},[_vm._v(_vm._s(_vm.translate('sameCategory')))]),_vm._v(" "),_c('div',{staticClass:"wrapper__labels"},[_c('TheCategoriesLabels',{attrs:{"categories":_vm.categories}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }